import './check-dependencies';
import './legacy/dfp-pixel';
import pkg                from '../package.json';
import app                from './application';
import Advertising        from './advertising';
import ConfigManager      from './config-manager';
import {isEmpty}          from './utils';
import {CONFIG_NAMESPACE} from './constants';
import { showLog } from './logger';
import { urlToSection } from './utils';

const {$} = window;
var _initialized = false;

_legacyInit();
$(document).ready(function() {
  var config = app.lookup(CONFIG_NAMESPACE);

  config = !isEmpty(config) ? config : {
    media:   window.configGDPMedio,
    options: window.configGDP
  };
  _init(config.media, config.options);
});

export const VERSION = pkg.version;

/* Private */

/**
 * Build legacy object
 * @deprecated
 */
function _legacyInit() {
  window.Vocento            = window.Vocento || {};
  window.Vocento.Publicidad = function() {};
  window.Vocento.Publicidad.prototype = {
    init(jQuery, configGDPMedio, configGDP) {
      _init(configGDPMedio, configGDP);
    },
    printAds(datos) {
      return Advertising.printAds(datos);
    },
    getOasSitepage(...params) {
      return Advertising.getOasSitepage(...params);
    },
    getSizesGoogle(...params) {
      return Advertising.getSizesGoogle(...params);
    },
    getValueUser(...params) {
      return Advertising.getValueUser(...params);
    }
  };
}

function _init(configGDPMedio, configGDP) {
  const voontoApp = 'Voonto' in window && 'getInstance' in window.Voonto
    ? window.Voonto.getInstance()
    : undefined;
  var configManager;

  if (_initialized) {return;}

  if (!configGDPMedio || !configGDP) {throw Error('[Ads Manager] missing configuration');}

  _initialized = true;
  // promise to wait advertising user consent
  voontoApp.when('consent:advertising').then(result => {
    showLog('Advertising Consent promise has been resolved with result: ', result);
    window.customcmd.push(() => {
      window.googletag.pubads().setRequestNonPersonalizedAds(result ? 0 : 1);
    });
  });

  voontoApp.on('consent:updated:advertising', (event, result) => {
    showLog('Advertising Consent has been updated with result: ', result);
    window.customcmd.push(() => {
      window.googletag.pubads().setRequestNonPersonalizedAds(result ? 0 : 1);
    });
  });

  configManager = new ConfigManager(configGDPMedio, configGDP);
  Advertising.init(configManager, false);
  _printAds();

  if (voontoApp) {
    voontoApp.on('voonto:reload', _reload);
    voontoApp.on('vam:refresh',   _refresh);
  }
  app.on('voonto:reload', _reload);
  app.on('vam:refresh',   _refresh);
}


/**
 * Print Ads configured inside context or whole page
 * Config must be passed to Advertising.init before calling printAds()
 * @param {null|jQueryObject} context$
 */
function _printAds(context$) {
  $('[data-voc-vam]', context$).each(function () {
    Advertising.printAds($(this));
  });
}

/**
 * Reload ads inside given context with given config
 * @param {jQueryEvent}       event
 * @param {null|jQueryObject} context$
 */
function _reload(event, context$) {
  const { media, options } = app.lookup(CONFIG_NAMESPACE);
  const rawSection         = context$.data('sectionUrl') || '';
  const forcedOas          = context$.data('voc-vam-force-oas') || '';
  const section            = urlToSection(rawSection);
  const oasOptions         = { section, forcedOas };
  let   configManager;

  configManager = new ConfigManager(media, options, oasOptions);

  if (context$.data('voc-vam-configgdp')) {
    context$.data('voc-vam-configgdp', null);
  }

  showLog('Reload event has been invoked. Config value: ', { media: configManager.configGDPMedio, options: configManager.configGDP });
  Advertising.init(configManager, true, context$);
  _printAds(context$);
}

/**
 * Refresh the ads position received on 'data' parameter
 * @param {string|object} data
 */
function _refresh(event, data) {
  var params = typeof data === 'string' ? JSON.parse(data) : data;

  Advertising.printAds(params);
}



// WEBPACK FOOTER //
// ./src/index.js